import Dialog from 'components/Dialog';
import React from 'react';
import {Grid} from '@mui/material';
import FormikTextField from 'components/inputs/FormikTextField';
import {FormFooterButtons} from 'components/buttons/FormFooterButtons';
import * as yup from 'common/yup';
import {INav} from 'features/layout/redux/helpers/FoldersHelper';
import {unpackId} from 'common/diplomatIdUtil';
import {useTranslation} from 'react-i18next';
import Formik from 'components/hook-form/Formik';
import {useRenameSftpGroup} from 'features/layout/CommonPage/panels/SFTP/hooks/useRenameSftpGroup';

const validationSchema = yup.object({
   groupName: yup.string().required(),
});

type Props = {
   data?: INav;
   onClose: () => void;
};

const RenameSftpGroupDialog = ({data, onClose}: Props) => {
   const {t} = useTranslation();
   const {id} = unpackId(data?.id);

   const {rename, validateName} = useRenameSftpGroup(id, onClose);

   return (
      <Dialog maxWidth="sm" header={t('Rename Group')} close={onClose}>
         <Formik initialValues={validationSchema.cast({userName: data?.name})} onSubmit={rename}>
            <>
               <Grid container spacing={2} justifyContent="center">
                  <Grid item xs={8}>
                     <FormikTextField
                        autoFocus
                        type="text"
                        name="groupName"
                        label={t('New Group Name:')}
                        required
                        validate={validateName}
                     />
                  </Grid>
               </Grid>
               <Grid item xs={12}>
                  <FormFooterButtons cancel={onClose} />
               </Grid>
            </>
         </Formik>
      </Dialog>
   );
};

export default RenameSftpGroupDialog;
